webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Examples__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Examples___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Examples__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Examples',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Examples___default.a
  }]
}));

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Progress__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Progress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Progress__);


var VueProgress = {
  install: function install(Vue, options) {
    Vue.component('progress-bar', __WEBPACK_IMPORTED_MODULE_0__Progress___default.a);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (VueProgress);

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(VueProgress);
}

/***/ }),
/* 8 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(18)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(14),
  /* template */
  __webpack_require__(28),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ANIMATE_DURATION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ANIMATE_DELAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return OPTIONS; });
var ANIMATE_DURATION = 1400;
var ANIMATE_DELAY = 400;

var LINE_BASIC = {
  strokeWidth: 4,
  easing: 'easeInOut',
  duration: ANIMATE_DURATION,
  color: '#FFEA82',
  trailColor: '#eee',
  trailWidth: 1,
  svgStyle: { width: '100%', height: '100%' }
};

var LINE_PERCENT = {
  strokeWidth: 4,
  easing: 'easeInOut',
  duration: ANIMATE_DURATION,
  color: '#FFEA82',
  trailColor: '#eee',
  trailWidth: 1,
  svgStyle: { width: '100%', height: '100%' },
  text: {
    style: {
      color: '#999',
      position: 'absolute',
      right: '0',
      top: '30px',
      padding: 0,
      margin: 0,
      transform: null
    },
    autoStyleContainer: false
  },
  from: { color: '#FFEA82' },
  to: { color: '#ED6A5A' },
  step: function step(state, bar) {
    bar.setText(Math.round(bar.value() * 100) + ' %');
  }
};

var LINE_COLOR_ANIMATION = {
  strokeWidth: 4,
  easing: 'easeInOut',
  duration: ANIMATE_DURATION,
  color: '#FFEA82',
  trailColor: '#eee',
  trailWidth: 1,
  svgStyle: { width: '100%', height: '100%' },
  from: { color: '#FFEA82' },
  to: { color: '#ED6A5A' },
  step: function step(state, bar) {
    bar.path.setAttribute('stroke', state.color);
  }
};

var CIRCLE_BASIC = {
  strokeWidth: 6,
  easing: 'easeInOut',
  duration: ANIMATE_DURATION,
  color: '#FFEA82',
  trailColor: '#eee',
  trailWidth: 1,
  svgStyle: null
};

var CIRCLE_BOUNCE_EASING = {
  color: '#FFEA82',
  trailColor: '#eee',
  trailWidth: 1,
  duration: ANIMATE_DURATION,
  easing: 'bounce',
  strokeWidth: 6,
  from: { color: '#FFEA82', a: 0 },
  to: { color: '#ED6A5A', a: 1 },

  step: function step(state, circle) {
    circle.path.setAttribute('stroke', state.color);
  }
};

var CIRCLE_MULTIPLE_PROPERTIES = {
  color: '#aaa',

  strokeWidth: 4,
  trailWidth: 1,
  easing: 'easeInOut',
  duration: ANIMATE_DURATION,
  text: {
    autoStyleContainer: false
  },
  from: { color: '#aaa', width: 1 },
  to: { color: '#333', width: 4 },

  step: function step(state, circle) {
    circle.path.setAttribute('stroke', state.color);
    circle.path.setAttribute('stroke-width', state.width);
    var value = Math.round(circle.value() * 100);
    if (value === 0) {
      circle.setText('');
    } else {
      circle.setText(value);
    }
  }
};

var CUSTOM_HEART = {
  easing: 'easeInOut',
  duration: ANIMATE_DURATION
};

var OPTIONS = {
  LINE_BASIC: LINE_BASIC,
  LINE_PERCENT: LINE_PERCENT,
  LINE_COLOR_ANIMATION: LINE_COLOR_ANIMATION,
  CIRCLE_BASIC: CIRCLE_BASIC,
  CIRCLE_BOUNCE_EASING: CIRCLE_BOUNCE_EASING,
  CIRCLE_MULTIPLE_PROPERTIES: CIRCLE_MULTIPLE_PROPERTIES,
  CUSTOM_HEART: CUSTOM_HEART
};

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_normalize_css_normalize_css__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_normalize_css_normalize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_normalize_css_normalize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vprogress__ = __webpack_require__(7);







__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vprogress__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LINE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CIRCLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PATH; });
var LINE = 'line';
var CIRCLE = 'circle';
var PATH = 'path';

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return extend; });
var extend = function extend(target, source) {
  for (var key in source) {
    target[key] = source[key];
  }
  return target;
};

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Card__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(10);






function loopAnimate(target) {
  target.animate(1.0, function () {
    setTimeout(target.animate(0, function () {
      setTimeout(loopAnimate(target), __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ANIMATE_DELAY */]);
    }), __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ANIMATE_DELAY */]);
  });
}

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0__Card___default.a
  },

  data: function data() {
    return {
      title: 'PrograssBar.js',
      subtitle: 'As a Vue Component',

      lineBasicOptions: __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* OPTIONS */].LINE_BASIC,
      linePercentOptions: __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* OPTIONS */].LINE_PERCENT,
      lineColorAnimationOptions: __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* OPTIONS */].LINE_COLOR_ANIMATION,
      circleBasicOptions: __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* OPTIONS */].CIRCLE_BASIC,
      circleBounceEasingOptions: __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* OPTIONS */].CIRCLE_BOUNCE_EASING,
      circleMultiplePropertiesOptions: __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* OPTIONS */].CIRCLE_MULTIPLE_PROPERTIES,
      customHeartOptions: __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* OPTIONS */].CUSTOM_HEART
    };
  },
  mounted: function mounted() {
    this.init();
  },


  methods: {
    init: function init() {
      var basicLine = this.$refs.basicLine;
      loopAnimate(basicLine);
      var percentLine = this.$refs.percentLine;
      loopAnimate(percentLine);
      var colorAnimationLine = this.$refs.colorAnimationLine;
      loopAnimate(colorAnimationLine);
      var basicCircle = this.$refs.basicCircle;
      loopAnimate(basicCircle);
      var bounceEasingCircle = this.$refs.bounceEasingCircle;
      loopAnimate(bounceEasingCircle);
      var multiplePropertiesCircle = this.$refs.multiplePropertiesCircle;
      loopAnimate(multiplePropertiesCircle);
      var customHeart = this.$refs.customHeart;
      loopAnimate(customHeart);
    }
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_progressbar_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_progressbar_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_progressbar_js__);






var RE_FLOAT = /^\d+(\.\d+)?$/;
var RE_INT = /^\+?[1-9][0-9]*$/;

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    type: {
      type: String,
      default: __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* LINE */],
      validator: function validator(val) {
        return val === __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* LINE */] || val === __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* CIRCLE */] || val === __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* PATH */];
      }
    },
    color: {
      type: String,
      default: '#555'
    },
    strokeWidth: {
      type: [Number, String],
      default: 1.0,
      validator: function validator(val) {
        return RE_FLOAT.test(val);
      }
    },
    trailColor: {
      type: String,
      default: '#eee'
    },
    trailWidth: {
      type: [Number, String],
      default: 0.5,
      validator: function validator(val) {
        return RE_FLOAT.test(val);
      }
    },
    duration: {
      type: [Number, String],
      default: 800,
      validator: function validator(val) {
        return RE_INT.test(val);
      }
    },
    easing: {
      type: String,
      default: 'linear'
    },
    svgStyle: Object,
    text: Object,
    fill: String,
    from: Object,
    to: Object,
    step: Function,
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  data: function data() {
    return {
      progress: undefined
    };
  },
  mounted: function mounted() {
    this.init();
  },
  destroyed: function destroyed() {
    if (this.progress) this.progress.destroy();
  },


  methods: {
    init: function init() {
      var _options = {
        color: this.color,
        strokeWidth: parseFloat(this.strokeWidth),
        trailColor: this.trailColor,
        trailWidth: parseFloat(this.trailWidth),
        duration: parseInt(this.duration),
        easing: this.easing
      };

      if (this.svgStyle) _options.svgStyle = this.svgStyle;
      if (this.text) _options.text = this.text;
      if (this.fill) _options.fill = this.fill;
      if (this.from) _options.from = this.from;
      if (this.to) _options.to = this.to;
      if (this.step) _options.step = this.step;

      var options = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* extend */])(_options, this.options || {});

      switch (this.type) {
        case __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* CIRCLE */]:
          this.progress = new __WEBPACK_IMPORTED_MODULE_2_progressbar_js__["Circle"](this.$el, options);
          break;
        case __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* PATH */]:
          var paths = this.$el.querySelectorAll('path');
          if (paths.length === 0) throw new Error('[VueProgress Error] Path not found in slot svg.');
          this.progress = new __WEBPACK_IMPORTED_MODULE_2_progressbar_js__["Path"](paths[paths.length - 1], options);
          break;
        default:
          this.progress = new __WEBPACK_IMPORTED_MODULE_2_progressbar_js__["Line"](this.$el, options);
      }
    },
    svg: function svg() {
      return this.progress.svg;
    },
    path: function path() {
      return this.progress.path;
    },
    trail: function trail() {
      return this.progress.trail;
    },
    text: function text() {
      return this.progress.text;
    },
    animate: function animate(progress, options, cb) {
      this.progress.animate(progress, options, cb);
    },
    set: function set(progress) {
      this.progress.set(progress);
    },
    stop: function stop() {
      this.progress.stop();
    },
    value: function value() {
      return this.progress.value();
    },
    setText: function setText(text) {
      this.progress.setText(text);
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 18 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 19 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(19)

var Component = __webpack_require__(2)(
  /* script */
  null,
  /* template */
  __webpack_require__(30),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(17)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(15),
  /* template */
  __webpack_require__(27),
  /* scopeId */
  "data-v-19a499da",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(16),
  /* template */
  __webpack_require__(29),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap"
  }, [_c('a', {
    staticClass: "github-corner",
    attrs: {
      "href": "https://github.com/wangdahoo/vue-progress",
      "aria-label": "View source on Github"
    }
  }, [_c('svg', {
    staticStyle: {
      "fill": "#ec4949",
      "color": "#fff",
      "position": "absolute",
      "top": "0",
      "border": "0",
      "right": "0"
    },
    attrs: {
      "width": "80",
      "height": "80",
      "viewBox": "0 0 250 250",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0,0 L115,115 L130,115 L142,142 L250,250 L250,0 Z"
    }
  }), _c('path', {
    staticClass: "octo-arm",
    staticStyle: {
      "transform-origin": "130px 106px"
    },
    attrs: {
      "d": "M128.3,109.0 C113.8,99.7 119.0,89.6 119.0,89.6 C122.0,82.7 120.5,78.6 120.5,78.6 C119.2,72.0 123.4,76.3 123.4,76.3 C127.3,80.9 125.5,87.3 125.5,87.3 C122.9,97.6 130.6,101.9 134.4,103.2",
      "fill": "currentColor"
    }
  }), _c('path', {
    staticClass: "octo-body",
    attrs: {
      "d": "M115.0,115.0 C114.9,115.1 118.7,116.5 119.8,115.4 L133.7,101.6 C136.9,99.2 139.9,98.4 142.2,98.6 C133.8,88.0 127.5,74.4 143.8,58.0 C148.5,53.4 154.0,51.2 159.7,51.0 C160.3,49.4 163.2,43.6 171.4,40.1 C171.4,40.1 176.1,42.5 178.8,56.2 C183.1,58.6 187.2,61.8 190.9,65.4 C194.5,69.0 197.7,73.2 200.1,77.6 C213.8,80.2 216.3,84.9 216.3,84.9 C212.7,93.1 206.9,96.0 205.4,96.6 C205.1,102.4 203.0,107.8 198.3,112.5 C181.9,128.9 168.3,122.5 157.7,114.1 C157.9,116.9 156.7,120.9 152.7,124.9 L141.0,136.5 C139.8,137.7 141.6,141.9 141.8,141.8 Z",
      "fill": "currentColor"
    }
  })])]), _vm._v(" "), _c('h1', {
    staticClass: "text-center",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "text-center",
    domProps: {
      "textContent": _vm._s(_vm.subtitle)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "text-left"
  }, [_vm._v("line")]), _vm._v(" "), _c('card', [_c('div', {
    slot: "content"
  }, [_c('progress-bar', {
    ref: "basicLine",
    staticClass: "line",
    attrs: {
      "type": "line",
      "options": _vm.lineBasicOptions
    }
  })], 1), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_vm._v("\n        basic line\n      ")])]), _vm._v(" "), _c('card', [_c('div', {
    slot: "content"
  }, [_c('progress-bar', {
    ref: "percentLine",
    staticClass: "line",
    attrs: {
      "type": "line",
      "options": _vm.linePercentOptions
    }
  })], 1), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_vm._v("\n        percent\n      ")])]), _vm._v(" "), _c('card', [_c('div', {
    slot: "content"
  }, [_c('progress-bar', {
    ref: "colorAnimationLine",
    staticClass: "line",
    attrs: {
      "type": "line",
      "options": _vm.lineColorAnimationOptions
    }
  })], 1), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_vm._v("\n        color animation\n      ")])]), _vm._v(" "), _c('h2', {
    staticClass: "text-left"
  }, [_vm._v("circle")]), _vm._v(" "), _c('card', [_c('div', {
    slot: "content"
  }, [_c('progress-bar', {
    ref: "basicCircle",
    staticClass: "circle",
    attrs: {
      "type": "circle",
      "options": _vm.circleBasicOptions
    }
  })], 1), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_vm._v("\n        basic circle\n      ")])]), _vm._v(" "), _c('card', [_c('div', {
    slot: "content"
  }, [_c('progress-bar', {
    ref: "bounceEasingCircle",
    staticClass: "circle",
    attrs: {
      "type": "circle",
      "options": _vm.circleBounceEasingOptions
    }
  })], 1), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_vm._v("\n        bounce easing\n      ")])]), _vm._v(" "), _c('card', [_c('div', {
    slot: "content"
  }, [_c('progress-bar', {
    ref: "multiplePropertiesCircle",
    staticClass: "circle",
    attrs: {
      "type": "circle",
      "options": _vm.circleMultiplePropertiesOptions
    }
  })], 1), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_vm._v("\n        multiple properties\n      ")])]), _vm._v(" "), _c('h2', {
    staticClass: "text-left"
  }, [_vm._v("custom")]), _vm._v(" "), _c('card', [_c('div', {
    slot: "content"
  }, [_c('progress-bar', {
    ref: "customHeart",
    staticClass: "heart",
    attrs: {
      "type": "path",
      "path-id": "heart-path",
      "options": _vm.customHeartOptions
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "version": "1.1",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 100 100"
    },
    slot: "svg"
  }, [_c('path', {
    attrs: {
      "fill-opacity": "0",
      "stroke-width": "1",
      "stroke": "#bbb",
      "d": "M81.495,13.923c-11.368-5.261-26.234-0.311-31.489,11.032C44.74,13.612,29.879,8.657,18.511,13.923  C6.402,19.539,0.613,33.883,10.175,50.804c6.792,12.04,18.826,21.111,39.831,37.379c20.993-16.268,33.033-25.344,39.819-37.379  C99.387,33.883,93.598,19.539,81.495,13.923z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "heart-path",
      "fill-opacity": "0",
      "stroke-width": "3",
      "stroke": "#ED6A5A",
      "d": "M81.495,13.923c-11.368-5.261-26.234-0.311-31.489,11.032C44.74,13.612,29.879,8.657,18.511,13.923  C6.402,19.539,0.613,33.883,10.175,50.804c6.792,12.04,18.826,21.111,39.831,37.379c20.993-16.268,33.033-25.344,39.819-37.379  C99.387,33.883,93.598,19.539,81.495,13.923z"
    }
  })])])], 1), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_vm._v("\n        heart\n      ")])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("svg")], 2)
},staticRenderFns: []}

/***/ }),
/* 30 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_vm._t("content")], 2), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._t("footer")], 2)])])
},staticRenderFns: []}

/***/ })
],[11]);


// WEBPACK FOOTER //
// static/js/app.f3e15ab8057d56db5227.js